import axios from "axios";
import axiosClient from "../axiosClient";

const route = "multiContainerInvoiceWithoutC";

export const getMultiContainerInvoices = async (params = {}) => {
  try {
    const response = await axiosClient.get(
      `${route}/filteredMultiContainerInvoices`,
      {
        params: {
          ...params,
        },
      },
    );

    return response;
  } catch (error) {
    console.error(error);
  }
};

export const getInvoiceById = async (invoiceId) => {
  try {
    const response = await axiosClient.get(
      `${route}/getMultiContainersInvoiceById`,
      {
        headers: {
          invoiceId: invoiceId,
        },
      },
    );

    return response;
  } catch (error) {
    console.error(error);
  }
};

// Function to get the archived multi container invoices
export const getArchivedMultiContainerInvoicesWithouC = async (params) => {
  const response = await axios.get(
    `${process.env.REACT_APP_URL}/getArchivedMultiContainersInvoicesWithoutC`,
    {
      params,
      headers: {
        "User-Id": params.userId,
        "Supplier-Id": params.supplierId,
        "Customer-Id": params.customerId || "All",
        "Organization-Id": params.organizationId,
      },
    },
  );
  return response;
};

export const saveNotes = async (invoiceId, notes) => {
  try {
    const response = await axiosClient.put(`${route}/addNotes/${invoiceId}`, {
      notes,
    });
    return response;
  } catch (error) {
    console.error(error);
  }
};
